import { FormattedMessage } from 'react-intl'
import { Link as RouterLink } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Alert from '@mui/material/Alert'
import { useTeams } from '../../contexts/TeamsContext'

function TeamsList() {
  const { teams, loading, error } = useTeams()

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Alert severity="error">
        <FormattedMessage id="teams.error" />
      </Alert>
    )
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5" component="h2">
          <FormattedMessage id="teams.title" />
        </Typography>
        <Button
          component={RouterLink}
          to="/teams/new"
          variant="contained"
          color="primary"
        >
          <FormattedMessage id="teams.createButton" />
        </Button>
      </Box>

      {teams.length === 0 ? (
        <Typography color="text.secondary">
          <FormattedMessage id="teams.empty" />
        </Typography>
      ) : (
        <List>
          {teams.map((team) => (
            <ListItem key={team.id} disablePadding>
              <ListItemButton component={RouterLink} to={`/teams/${team.slug}`}>
                <ListItemText primary={team.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  )
}

export default TeamsList
